import CentersBand from '../../components/home/CentersBand';
import Hero from '../../components/home/Hero';
import InterestSection from '../../components/home/InterestSection';
import NewsSection from '../../components/home/NewsSection';
import ProfilesSection from '../../components/home/ProfilesSection';
import QuickAccessGrid from '../../components/home/QuickAccessGrid';
import Banner from '../../components/home/Banner';

export default function HomePage() {
  return (
    <>
      <Hero />
      <QuickAccessGrid />
      <Banner />
      <ProfilesSection />
      <CentersBand />
      <InterestSection />
      <NewsSection />
    </>
  );
}
